import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DealerBackBar")
);

const DealerDataEditConfig = {
  emptyLabel: "Dealer Data",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const DealerData = (props) => {
  window.LEXUS = window.LEXUS || {};
  window.LEXUS.dealerData = props.dealer;
  return <Component />;
};

export default withAemIntegration(
  "lexus/components/dealer-details/dealer-data"
)(DealerData, DealerDataEditConfig);
